var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTrash = function SvgTrash(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 45,
    viewBox: "0 0 35 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 40C2.5 42.75 4.75 45 7.5 45H27.5C30.25 45 32.5 42.75 32.5 40V10H2.5V40ZM8.65 22.2L12.175 18.675L17.5 23.975L22.8 18.675L26.325 22.2L21.025 27.5L26.325 32.8L22.8 36.325L17.5 31.025L12.2 36.325L8.675 32.8L13.975 27.5L8.65 22.2ZM26.25 2.5L23.75 0H11.25L8.75 2.5H0V7.5H35V2.5H26.25Z",
    fill: "#0040BF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTrash);
export default ForwardRef;